import { readonly, ref, watchEffect, type Ref } from 'vue'
import { useAuth } from '@/composables/useAuth'

/**
 * Bekommt dieser Zugang die schlanke Kiosk-Hülle (Branding + nur sein
 * Werkzeug) statt des vollen Admin-Chrome? Ja für die Rolle `client`.
 *
 * Die Antwort wechselt nur, wenn ein Zugang DA ist. Beim Abmelden wird `user`
 * null, bevor die Anmeldeseite erscheint. Folgte die Hülle dem sofort, sprang
 * sie bei einer Kundin von Kiosk auf Admin, der Editor wurde darin neu
 * aufgebaut und lud ohne Sitzung: „Laden fehlgeschlagen, HTTP 401" auf der
 * Anmeldeseite (gefunden 02.10.2026). Beim Admin trat es nicht auf, weil
 * seine Hülle gleich bleibt.
 */
export function useKioskHuelle(): Readonly<Ref<boolean>> {
  const { user } = useAuth()
  const kiosk = ref(false)
  watchEffect(() => {
    if (user.value) kiosk.value = user.value.role === 'client'
  })
  return readonly(kiosk)
}
